<!-- 区域数据展板全景 -->
<template>
  <div class="school-data-board">
    <div class="school-data-board-top">
      <div class="school-data-board-top-title">
        <div class="title" @click="changeRouter(0)">
          高新智慧学校-{{ path[0].title }}
        </div>
        <div class="left-btn">
          <div class="name" @click="changeRouter(1)">
            {{ path[1].title }}</div>
        </div>
        <div class="right-btn">
          <div class="name" @click="changeRouter(2)">
            {{ path[2].title }}</div>
        </div>
      </div>
      <div class="school-data-board-top-filter">
        <div class="filter-btn" @click="changeFilter('all')" :class="filterSelect == 'all' ? 'is-select' : ''">全部</div>
        <div class="filter-btn" @click="changeFilter('year')" :class="filterSelect == 'year' ? 'is-select' : ''">本学年</div>
        <div class="filter-btn" @click="changeFilter('month')" :class="filterSelect == 'month' ? 'is-select' : ''">本月
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'school-data-board',
  data() {
    return {
      path: [
        { 'title': '教研', 'path': '/schoolresearch' },
        { 'title': '资源', 'path': '/schoolresource' },
        { 'title': '教学', 'path': '/schoolteaching/5ee5b923177a45aeb8133caaed684003' }
      ]
    }
  },
  methods: {
    changeRouter(value) {
      this.$router.push({
        path: this.path[value].path
      })
      this.path.unshift(this.path.splice(value, 1)[0]);
    },
  },
  watch: {

  },
  computed: {

  },
  mounted() {
    // this.path = this.$route.path
  },
}
</script>
<style lang="scss" scoped>
.school-data-board {
  width: 100%;
  height: auto;
  min-height: 100%;
  background: url('../../../assets/images/databoard/bg5.png');

  .school-data-board-top {
    color: #fff;
    height: 126px;
    width: 100%;
    position: relative;
    background-color: rgba(6, 17, 52, 0.8);

    .school-data-board-top-title {
      // width: calc(100% - 200px);
      width: 1690px;
      height: 95px;
      margin: 0 auto;
      background: url('../../../assets/images/sydataboard/头部背景图.png') no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: relative;

      .title {
        display: inline-block;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 20px;
      }

      .left-btn {
        position: absolute;
        left: 20%;
        display: flex;
        top: 25px;

        .name {
          width: 170px;
          height: 45px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 40px;
          color: rgba(255, 255, 255, 0.5);
          background: url('../../../assets/images/sydataboard/模块切换.png') no-repeat;
          background-size: 100% 100%;
          margin-right: 20px;
          cursor: pointer;

          &:hover {
            color: #FFFFFF;
          }
        }
      }

      .right-btn {
        position: absolute;
        right: 20%;
        display: flex;
        top: 25px;

        .name {
          width: 170px;
          height: 45px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 40px;
          color: rgba(255, 255, 255, 0.5);
          background: url('../../../assets/images/sydataboard/模块切换.png') no-repeat;
          background-size: 100% 100%;
          margin-left: 20px;
          cursor: pointer;

          &:hover {
            color: #FFFFFF;
          }
        }
      }
    }

    .school-data-board-top-full {
      position: absolute;
      right: 20px;
      bottom: 40px;
      cursor: pointer;

      .full-title {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2773E6;
        margin-left: 5px;
      }
    }

    .school-data-board-top-filter {
      position: absolute;
      left: 20px;
      bottom: 10px;
      display: flex;
      align-items: center;
      background: rgba(31, 51, 141, 0.57);
      border-radius: 4px;

      .filter-btn {
        padding: 9px 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C1ECFF;
        cursor: pointer;
      }

      .is-select {
        background: #2B7FFF;
        border-radius: 4px;
        color: #FFFFFF;
      }
    }
  }
}
</style>